import Cookies from 'js-cookie';

export const IDENTIFIER_COOKIE_NAMES = {
  sessionId: 'brij-session-id',
  deviceId: 'brij-device-id',
} as const;

// Redirect service is now the single source of truth for these identifiers.
// The client reads the cookies directly and does not generate local fallback IDs,
// which keeps analytics and downstream API calls aligned with redirect traffic.
export const getIdentifierCookie = (
  cookieName: (typeof IDENTIFIER_COOKIE_NAMES)[keyof typeof IDENTIFIER_COOKIE_NAMES]
): string => Cookies.get(cookieName) || '';

export const getSessionIdFromCookie = (): string =>
  getIdentifierCookie(IDENTIFIER_COOKIE_NAMES.sessionId);

export const getDeviceIdFromCookie = (): string =>
  getIdentifierCookie(IDENTIFIER_COOKIE_NAMES.deviceId);
